export type Geschlecht = 'w' | 'm' | 'd';

export interface GeschlechtCategory {
  label: string;
  key: Geschlecht;
}

export const GESCHLECHT_CATEGORIES: GeschlechtCategory[] = [
  { label: 'weiblich', key: 'w' },
  { label: 'männlich', key: 'm' },
  { label: 'divers', key: 'd' }
];
